<template>
  <Page
    title="Usuários"
    :filterable="true"
    :filter.sync="filter"
    @update:filter="getUsers()"
  >
    <template v-slot:actions>
      <div>
        <v-btn @click="handleClickNewUser" color="primary" tile>
          <v-icon left>mdi-plus</v-icon>
          Cadastrar
        </v-btn>
      </div>
    </template>
    <v-container style="max-width: 1100px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="getUsers()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="users"
          :items-per-page="5"
          class="elevation-1"
          :disabled="loading"
          :options.sync="options"
          :server-items-length="totalUsers"
          :loading="loading"
          loading-text="Carregando..."
          fixed-header
          max-height="500"
        >
          <template v-slot:item.avatar_url="{ item }">
            <user-avatar
              :avatar_url="item.avatar_url"
              :user_name="item.name"
              :user_id="item.id"
              size="40"
            />
          </template>
          <template v-slot:item.name="{ item }">
            <router-link :to="'/admin/users/' + item.id">
              {{ item.name }}
            </router-link>
          </template>
          <template v-slot:item.is_admin="{ item }">
            <v-chip v-if="item.is_admin" color="primary" label small>
              Administrador
            </v-chip>
            <v-chip v-else label small>Padrão</v-chip>
          </template>
          <template v-slot:item.role_name="{ item }">
            <role-chip
              :role="{
                name: item.role_name,
                description: item.role_description
              }"
            ></role-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn @click="handleClickEditUser(item.id)" icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog" width="600px" persistent>
        <user-form
          @cancel="handleCloseDialog"
          @submit="handleSubmitForm"
          :id="selected_id"
        ></user-form>
      </v-dialog>

      <v-dialog v-model="confirmation" width="300px">
        <v-card>
          <v-card-title class="headline">Tem certeza?</v-card-title>

          <v-card-text>O usuário será permanentemente excluído</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              text
              @click="confirmation = false"
              :disabled="delete_loading"
              >Não</v-btn
            >

            <v-btn
              color="primary"
              text
              @click="confirmDelete()"
              :loading="delete_loading"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </Page>
</template>

<script>
import UserForm from "../components/forms/UserForm";
import RoleChip from "../components/forms/RoleChip";
import UserAvatar from "@/components/users/UserAvatar";
import Page from "@/components/layout/Page";

export default {
  name: "users",
  components: { UserForm, RoleChip, UserAvatar, Page },
  data: () => ({
    items: [
      {
        text: "Usuários"
      }
    ],
    dialog: false,
    filter: "",
    loading: false,
    headers: [
      {
        text: "",
        value: "avatar_url",
        sortable: false,
        align: "center",
        width: "70px"
      },
      {
        text: "Nome",
        value: "name"
      },
      {
        text: "Tipo",
        value: "is_admin"
      },
      {
        text: "Função",
        value: "role_name"
      },
      {
        text: "Email",
        value: "email"
      },
      {
        text: "",
        value: "actions",
        align: "right",
        width: "110px",
        sortable: false
      }
    ],
    users: [],
    totalUsers: 0,
    options: {
      itemsPerPage: 10,
      sortBy: ["name"]
    },
    selected_id: null,
    confirmation: false,
    delete_loading: false
  }),
  methods: {
    filterUser(filter) {
      this.filter = filter;
      this.getUsers();
    },
    indexUsers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      return this.$http.get(
        `/users?&page=${page}&perPage=${itemsPerPage}&orderBy=${
          sortBy[0] ? sortBy[0] : ""
        }&sortDesc=${sortDesc[0] ? sortDesc[0] : ""}&filter=${this.filter}`
      );
    },
    async getUsers() {
      this.loading = true;
      this.users = [];
      const response = await this.indexUsers();
      const data = response.data;
      this.users = data.data;
      this.totalUsers = data.total;
      this.loading = false;
    },
    deleteUser(id) {
      return this.$http.delete(`/users/${id}`);
    },
    handleClickNewUser() {
      this.selected_id = null;
      this.dialog = true;
    },
    handleSubmitForm() {
      this.selected_id = null;
      this.dialog = false;
      this.getUsers();
    },
    handleClickEditUser(id) {
      this.$router.push("/admin/users/" + id);
    },
    handleCloseDialog() {
      this.selected_id = null;
      this.dialog = false;
    },
    handleClickDelete(user_id) {
      this.confirmation = true;
      this.selected_id = user_id;
    },
    async confirmDelete() {
      this.delete_loading = true;
      try {
        await this.deleteUser(this.selected_id);
        this.confirmation = false;
        this.getUsers();
        this.$store.commit("sendMessage", {
          text: "Usuário excluído com sucesso!"
        });
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: message
        });
      } finally {
        this.delete_loading = false;
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.users {
}
</style>
